import {Action} from '@reduxjs/toolkit'
import moment from 'moment'
import {persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  SetFilter: '[Incident SetFilter] Action',
  ResetFilter: '[Incident ResetFilter] Action',
}

const initialIncidentState: IIncidentState = {
  filter: {
    statusId: '',
    typeId: '',
    siteId: '',
    start: '',
    end: '',
    pagination: {
      currentPage: 1,
      totalRecords: 1,
      totalPages: 1,
      skip: 0,
      take: 50,
      reset: true,
      sort: 'created',
      direction: 'desc',
    },
  },
}

export interface IIncidentState {
  filter?: {
    statusId: string
    typeId: string
    siteId: string
    start: any
    end: any
    pagination: any
  }
}

export const reducer = persistReducer(
  {storage, key: 'v100-Incident', whitelist: ['filter']},
  (state: IIncidentState = initialIncidentState, action: ActionWithPayload<IIncidentState>) => {
    switch (action.type) {
      case actionTypes.ResetFilter: {
        return initialIncidentState
      }

      case actionTypes.SetFilter: {
        const filter = action.payload?.filter
        return {...state, filter}
      }

      default:
        return state
    }
  }
)

export const Actions = {
  resetFilter: () => ({type: actionTypes.ResetFilter}),
  setFilter: (filter: object) => ({
    type: actionTypes.SetFilter,
    payload: {filter},
  }),
}

export function* saga() {}
